import {useMutation} from '@tanstack/vue-query';
import { getApi } from '../api';

export default (accountId: number) => useMutation({
    mutationFn: (dialogId: number) => {
        const { api, baseURL } = getApi();
        return api.delete(`/api/v2/accounts/${accountId}/dialogs/${dialogId}`, { baseURL, useOriginalToken: true }).then(res => res.data.data)
    },
})
